import type { IconNode } from '../types';

/**
 * @name bra-sports
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTcgMjEtOS05VjNINHYxMC42QTQgNCAwIDAgMCA2IDIxaDEyYTQgNCAwIDAgMCAyLTcuNFYzaC00djlsLTQgNCIgLz4KICA8cGF0aCBkPSJNOCAxMWg4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bra-sports
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const braSports: IconNode = [
  [
    'path',
    { d: 'm17 21-9-9V3H4v10.6A4 4 0 0 0 6 21h12a4 4 0 0 0 2-7.4V3h-4v9l-4 4', key: '1sqfmw' },
  ],
  ['path', { d: 'M8 11h8', key: 'vwpz6n' }],
];

export default braSports;
